// extracted by mini-css-extract-plugin
module.exports = {"typeBonus":"styles_typeBonus__YaXrl","bonusesContainer":"styles_bonusesContainer__BEfCJ","bonusesQueue":"styles_bonusesQueue__l95xN"};